/* eslint-disable comma-dangle */
import api from '@/api';
import {
  CONFLICT,
  NOT_ACCEPTABLE,
  NOT_FOUND,
  UNAUTHORIZED,
  UNPROCESSABLE_ENTITY
} from '../../enums/errorEnums';

const baseAPI = `${process.env.VUE_APP_BASE_API}/Person`;
const HANDLED_ERRORS = [NOT_ACCEPTABLE, CONFLICT, UNPROCESSABLE_ENTITY, UNAUTHORIZED, NOT_FOUND];

const errorValidate = (response) => {
  let errors = null;
  const { status } = response;
  if (HANDLED_ERRORS.includes(status)) {
    errors = {
      status,
      statusText: response.statusText || response.data.message,
    };
  }

  return errors;
};

export default {
  register: async ({
    name, email, password, genderId
  }) => {
    const response = await api.post(`${baseAPI}`, {
      name,
      email: email.toLowerCase(),
      password,
      genderId,
    });

    const errors = errorValidate(response);

    return {
      ...response,
      errors,
    };
  },
  getAll: async () => {
    const response = await api.get(baseAPI);

    const errors = errorValidate(response);

    const { data } = response

    return {
      data,
      errors,
    };
  },
  getMe: async () => {
    const response = await api.get(`${baseAPI}/me`);

    const errors = errorValidate(response);

    const { data } = response

    return {
      data,
      errors,
    };
  },
  getById: async (personId) => {
    const response = await api.get(`${baseAPI}/${personId}`);

    const errors = errorValidate(response);

    const { data } = response

    return {
      data,
      errors,
    };
  },
  getByEmail: async (email) => {
    const response = await api.get(`${baseAPI}/email/${email}`);

    const errors = errorValidate(response);

    const { data } = response

    return {
      data,
      errors,
    };
  },
  updateProfile: async ({ payload }) => {
    const response = await api.put(`${baseAPI}`, payload);

    const errors = errorValidate(response);

    const { data } = response

    return {
      data,
      errors,
    };
  },
  uploadCV: async ({ file }) => {
    const formData = new FormData();
    formData.append('file', file);
    const response = await api.post(`${baseAPI}/upload-documents`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    });

    const errors = errorValidate(response);

    const { data } = response

    return {
      data,
      errors,
    };
  },
  downloadCV: async ({ fileName }) => {
    const response = await api.post(`${baseAPI}/download-documents`, { fileName });

    const errors = errorValidate(response);

    const { data } = response

    return {
      data,
      errors,
    };
  },
  downloadCVByEmail: async ({ fileName, email }) => {
    const response = await api.get(
      `${baseAPI}/download-documents-by-email?fileName=${fileName}&email=${email}`
    );

    const errors = errorValidate(response);

    const { data } = response

    return {
      data,
      errors,
    };
  },
};
